import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import LuatssProGamer from './LuatssProGamer.tsx';

ReactDOM.render(
  <React.StrictMode>
    <LuatssProGamer />
  </React.StrictMode>,
  document.getElementById('root')
);
